<script>
import AppIcon from "@/features/general/Icons";
import AppSvg from "@/features/general/Svg";
import { FontAwesomeIcon, SvgIcon } from "./icon";

export default {
  name: "AppOrderPaymentMethodIcon",
  components: {
    AppIcon,
    AppSvg,
  },

  props: {
    paymentMethodName: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "62px",
    },
    height: {
      type: String,
      default: "43px",
    },
    fontSize: {
      type: String,
      default: "45px",
    },
  },

  data() {
    return {
      icons: [
        new FontAwesomeIcon("far", "envelope", "transfer"),
        new SvgIcon("billet", "boleto"),
        new SvgIcon("deposit", "deposito"),
        new SvgIcon("amex"),
        new SvgIcon("aura"),
        new SvgIcon("banrisul"),
        new SvgIcon(
          "bb",
          (search) => search.indexOf("bb") > -1 || search.indexOf("brasil") > -1
        ),
        new SvgIcon("bradesco"),
        new SvgIcon("diners"),
        new SvgIcon("discover"),
        new SvgIcon("elo"),
        new SvgIcon(
          "hiper",
          (search) =>
            search.indexOf("hipercard") === -1 && search.indexOf("hiper") > -1
        ),
        new SvgIcon("hipercard"),
        new SvgIcon("hsbc"),
        new SvgIcon("itau"),
        new SvgIcon("jcb"),
        new SvgIcon("maestro"),
        new SvgIcon("mastercard"),
        new SvgIcon(
          "visa",
          (search) =>
            search.indexOf("visaelectron") === -1 && search.indexOf("visa") > -1
        ),
        new SvgIcon("visaelectron"),
        new SvgIcon("bcash"),
        new SvgIcon("mercadopago"),
        new SvgIcon("curious-woman"),
        new SvgIcon("moip"),
        new SvgIcon("pagseguro"),
        new SvgIcon("paypal"),
        new SvgIcon("peela"),
        new SvgIcon("traycheckout"),
        new SvgIcon("pix"),
        new FontAwesomeIcon("fa", "credit-card", "cartao"),
        new FontAwesomeIcon("fas", "barcode", () => true), // Para o caso de nenhum ícone corresponder.
      ],
    };
  },

  /**
   * Carrega o ícone.
   *
   * @return {object}
   * @private
   * */
  computed: {
    icon() {
      let data = null;
      const methodName = this.paymentMethodName.replace(/\s/g, "");
      // eslint-disable-next-line no-return-assign
      this.icons.some(
        (icon) => icon.match(methodName) && !!(data = icon.getDef())
      );

      return data;
    },
  },
};
</script>
<template>
  <app-icon
    v-if="icon && icon.type === 'font'"
    v-bind:style="{ width, height, fontSize }"
    class="d-flex align-items-center justify-content-center"
    :prefix="icon.prefix"
    :name="icon.name"
  ></app-icon>

  <app-svg
    v-else-if="icon && icon.type === 'svg'"
    v-bind:style="{ width, height }"
    class="d-flex align-items-center justify-content-center"
    :name="icon.name"
  ></app-svg>
</template>
